<template>
  <div>
    <div class="level no-margin">
      <div class="level-left">
        <div class="level-item">
          <span class="button-padding-right" v-if="data.length > 0"
            >Status:
            <a
              href="#"
              class="inactiveLink"
              v-bind:class="getWorkFlowStatusClass"
              >{{ this.workflowStatus }}</a
            ></span
          >
          <span
            class="button-padding-right"
            v-if="this.workflowStatus == 'Approved'"
            >Approved on:
            <a
              href="#"
              class="inactiveLink"
              v-bind:class="getWorkFlowStatusClass"
              >{{ this.updateDate }}</a
            >
          </span>

          <span v-if="isCdfRejected" class="additional-info">
            <b-tooltip type="is-primary" :label="rejectionComment" multilined>
              <i class="mdi mdi-information"></i>
            </b-tooltip>
          </span>
          <div class="button-padding-right">
            <b-button
              v-if="isEnabled()"
              slot="right"
              type="is-success"
              @click="approveCDF"
              outlined
            >
              Approve
            </b-button>
          </div>

          <div class="button-padding-right">
            <b-button
              v-if="isEnabled()"
              slot="right"
              type="is-danger"
              @click="isCardModalActive = true"
              outlined
            >
              Reject
            </b-button>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item-horizontal">
          <ul
            class="context-options-right button-padding-right"
            v-if="data.length > 0"
          >
            <u>
              <a
                v-if="!cdfAction"
                slot="right"
                type="is-primary"
                @click="generateCDFConfirm"
              >
                Generate
              </a>
            </u>
          </ul>
        </div>
        <div class="level-item-horizontal" v-if="!cdfAction">
          <ul
            class="context-options-right button-padding-right"
            v-if="data.length > 0"
          >
            <u>
              <a
                href="#"
                type="is-primary"
                @click="exportCDFTransactionTemplate"
              >
                Export
              </a>
            </u>
          </ul>
        </div>
        <div
          class="level-item-horizontal button-padding-right"
          v-if="!cdfAction"
        >
          <b-button
            v-if="!cdfAction && valueChange"
            @click="saveAsDraft"
            class="save-as-draft-button"
          >
            Save as Draft
          </b-button>
        </div>
        <div class="level-item-horizontal" v-if="data.length > 0">
          <b-button
            v-if="!cdfAction"
            slot="right"
            type="is-primary"
            @click="sendForApproval"
          >
            Send for Approval
          </b-button>
        </div>
      </div>
    </div>
    <div class="columns" v-if="data.length > 0">
      <div class="column">
        <circul8-table
          :records="data"
          :fields="columns"
          :routeNext="false"
          :usePropRecords="true"
          :listingComponent="true"
          @clickEdit="editModal"
          @clickView="viewModal"
          @clickDelete="deleteModal"
          :showRemoveButton="showDelete"
          :showEditButton="showEdit"
          @clickcheck="checkCheckBox"
          @switchRequire="switchRequired"
          :maxTextLength="'40'"
          :isCheckable="false"
          :isLoading="isDataLoading"
        />
      </div>
    </div>
    <div class="columns" v-else>
      <section class="section records-posisiton-adjust empty-table-cdf">
        <b-table :data="[]" :narrowed="true">
          <template #empty>
            <div class="has-text-centered">
              <span
                >If you already added a report, click below to generate a CDF
                template</span
              >
              <br /><br />
              <b-button
                v-if="!cdfAction"
                type="is-primary"
                outlined
                @click="generateCDFConfirm"
              >
                Generate
              </b-button>
            </div>
          </template>
        </b-table>
      </section>
    </div>
    <b-modal v-model="isCardModalActive" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title title-reject">
            You are rejecting the changes
          </p>
        </header>
        <section class="modal-card-body">
          <b-field label="Please describe the reasons">
            <b-input
              maxlength="500"
              type="textarea"
              v-model="rejectComment"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button
            label="Close"
            class="reject-modal-close-button"
            @click="isCardModalActive = false"
          />
          <b-button label="Reject" type="is-danger" @click="rejectCDF" />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import CDFTransactionDataService from "../../services/CDFTransactionDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import { CDFWorkflowStatus } from "../../constants/CDFWorkflowStatus";
import utilityMixin from "@/mixins/UtilityMixin";
import * as dayjs from "dayjs";
// @group Customers
export default {
  name: "CDFtransactionData",
  mixins: [utilityMixin],
  components: { Circul8Table },
  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    cdfAction: {
      type: Boolean,
      default: false
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: [],
      originalCdfResponse: [],
      customerTransactionCdfId: null,
      workflowStatus: null,
      updateDate: null,
      rejectionComment: null,
      isCdfRejected: null,
      isModalActive: false,
      isAdd: false,
      action: null,
      editObject: null,
      isDataLoading: false,
      paginated: true,
      perPage: 10,
      requiredRow: [],
      isCardModalActive: false,
      rejectComment: null,
      valueChange: false,
      columns: [
        // {
        //   field: "id",
        //   label: "ID",
        //   searchable: true
        // },
        {
          field: "field_name",
          label: "CDF Field Name",
          searchable: true
        },
        {
          field: "field_required",
          label: "Required",
          customSwitchComponent: true,
          disableSwitch: this.cdfAction,
          width: "20",
          cellClass: "required-switch-button"
        }
      ],
      CDFTransactionDataService: new CDFTransactionDataService()
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),

    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },

    disableGenerate() {
      // Generate transaction cdf is possible only first time
      if (this.cdfAction == true) {
        return false;
      } else if (this.data.length > 1) {
        return false;
      }
      return true;
    },

    getWorkFlowStatusClass() {
      switch (this.workflowStatus) {
        case CDFWorkflowStatus.DRAFT:
          return "is-link";
        case CDFWorkflowStatus.SENT_FOR_APPROVAL:
          return "is-warning";
        case CDFWorkflowStatus.APPROVED:
          return "is-success";
        case CDFWorkflowStatus.REJECTED:
          return "is-danger";
        default:
          return "is-info";
      }
    }
  },
  mounted() {
    this.fetchCDFTransactionData();
  },
  methods: {
    checkCheckBox(d) {
      this.checkedRows = d;
    },
    switchRequired(d) {
      this.requiredRow = d;
      this.valueChange = true;
    },
    isEnabled() {
      if (this.cdfAction == true) {
        // this is View action
        return false;
      } else if (
        this.workflowStatus == CDFWorkflowStatus.SENT_FOR_APPROVAL &&
        (this.isUserAdmin() ||
          (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
            (this.customerAccountManager == this.userId ||
              this.backupCustomerAccountManager == this.userId)))
      ) {
        return true;
      }
      return false;
    },
    getClearFormObject() {
      return {
        id: null,
        first_name: null,
        last_name: null,
        email: null,
        position: null,
        contract_type: null,
        send_reminder: null
      };
    },
    addModal() {
      this.isAdd = false;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = false;
      this.action = "Update";
      this.editObject = editObject;
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = true;
      this.action = "View";
      this.editObject = editObject;
      this.isModalActive = true;
    },
    editConfirm(d) {
      if (d) {
        this.fetchContactInformationData();
      }
      this.isModalActive = false;
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    deleteModal(editObject) {
      this.isAdd = true;
      this.action = "Delete";
      this.editObject = editObject;
      this.isModalActive = true;
    },

    isEditAllowed(data) {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          data.account_manager_id == this.userId)
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    isUserAdmin() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        return true;
      }
      return false;
    },
    checkCdfDataGenerated(message) {
      if (
        this.originalCdfResponse == null ||
        this.originalCdfResponse == undefined
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: message,
          type: "is-danger"
        });
        return false;
      }
      return true;
    },
    prepareData(data) {
      this.originalCdfResponse = data[0];
      if (
        this.originalCdfResponse != null ||
        this.originalCdfResponse != undefined
      ) {
        this.customerTransactionCdfId = this.originalCdfResponse["id"];
        this.workflowStatus = this.originalCdfResponse["status"];
        this.updateDate = dayjs(this.originalCdfResponse["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        this.rejectionComment = this.originalCdfResponse[
          "comment_for_rejection"
        ];
        this.isCdfRejected = this.workflowStatus == "Rejected" ? true : false;
        const filteredTemplateFieldData = this.originalCdfResponse[
          "template_fields"
        ].filter(item => item.template_field !== "weight_in_kg");
        this.data = filteredTemplateFieldData;
      }
    },

    fetchCDFTransactionData() {
      const hasNADropdown = false;
      this.isDataLoading = true;
      this.CDFTransactionDataService.getCdfTransactionField(
        this.$route.params.id,
        hasNADropdown
      ).subscribe(
        response => {
          this.prepareData(response);
          this.isDataLoading = false;
        },
        e => {
          this.isDataLoading = false;
        }
      );
    },
    handleApiError(reason) {
      let errorMessage = null;
      if (reason?.response?.data) {
        if (reason.response.data["detail"]) {
          errorMessage = reason.response.data["detail"];
        } else if (reason.response.data["error"]) {
          errorMessage = reason.response.data["error"];
        } else if (reason.response.data["name"]) {
          errorMessage = reason.response.data["name"];
        }
      }

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
    },
    generateCDFConfirm() {
      this.isDataLoading = true;
      if (
        this.originalCdfResponse != null ||
        this.originalCdfResponse != undefined
      ) {
        this.originalCdfResponse["template_fields"] = this.data;
      } else {
        this.originalCdfResponse = { customer: this.$route.params.id };
      }
      this.CDFTransactionDataService.generateCDF(
        this.customerTransactionCdfId,
        this.originalCdfResponse
      ).subscribe(response => {
        this.prepareData(response);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "CDF Transaction Template Generated",
          type: "is-success"
        });
      }, this.handleApiError);
    },
    sendForApproval() {
      this.isDataLoading = true;
      if (
        !this.checkCdfDataGenerated(
          "No CDF data available to send for approval, please generate CDF first"
        )
      ) {
        return;
      }
      this.originalCdfResponse["template_fields"] = this.data;
      this.CDFTransactionDataService.sendForApproval(
        this.customerTransactionCdfId,
        this.originalCdfResponse
      ).subscribe(response => {
        this.prepareData(response);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "CDF Transaction Template Sent for Approval!",
          type: "is-success"
        });
      }, this.handleApiError);
    },
    saveAsDraft() {
      this.isDataLoading = true;
      if (
        !this.checkCdfDataGenerated(
          "No CDF data available to save, please generate CDF first"
        )
      ) {
        return;
      }
      this.originalCdfResponse["template_fields"] = this.data;
      this.CDFTransactionDataService.saveAsDraft(
        this.customerTransactionCdfId,
        this.originalCdfResponse
      ).subscribe(response => {
        this.prepareData(response);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "CDF Transaction Template Updated!",
          type: "is-success"
        });
      }, this.handleApiError);
    },
    approveCDF() {
      this.isDataLoading = true;
      this.CDFTransactionDataService.approve(
        this.customerTransactionCdfId
      ).subscribe(response => {
        this.prepareData(response);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "CDF Transaction Template Approved!",
          type: "is-success"
        });
      }, this.handleApiError);
    },
    showComment() {
      this.$buefy.dialog.alert({
        title: "Additional Information",
        message: this.rejectionComment
      });
    },
    exportCDFTransactionTemplate() {
      if (
        !this.checkCdfDataGenerated(
          "No CDF data available to export, please generate CDF first"
        )
      ) {
        return;
      }
      try {
        this.CDFTransactionDataService.cdfTransactionTemplateExport(
          this.$route.params.id
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    rejectCDF() {
      this.isCardModalActive = false;
      this.isDataLoading = true;
      this.CDFTransactionDataService.reject(
        this.customerTransactionCdfId,
        this.rejectComment
      ).subscribe(response => {
        this.prepareData(response);
        this.isDataLoading = false;
        this.$buefy.toast.open({
          message: "CDF Transaction Template Rejected!",
          type: "is-danger"
        });
      }, this.handleApiError);
    },
    updateField() {
      this.isDataLoading = true;
      this.CDFTransactionDataService.update(this.$route.params.id).subscribe(
        response => {
          this.isDataLoading = false;
        },
        e => {
          console.log(e);
        }
      );
    }
  }
};
</script>
